import { getTraders } from "@Shared/api/traders.api";
import { useQuery } from "@tanstack/react-query";
import CustomReactSelect, { SelectOption } from "@Modules/core/components/form/CustomReactSelect";
import TraderSelectOption from "@Shared/components/form/TraderSelectOption";
import { FormControl, FormLabel } from "@chakra-ui/react";

export function TraderSelect() {
  const { isLoading, error, data } = useQuery({
    queryKey: ['tradersData'],
    queryFn: () =>
      getTraders().then(
        (res) => res.data
      ),
  });

  const traderOptions: readonly SelectOption[] = data ? data.map(item => ({label: item.name, value: item.id})) : []

  if (error) return <div>An error has occurred</div>;

  return (
    <FormControl>
      <FormLabel htmlFor={'trader'} fontWeight={'normal'}>
        Commerçant
      </FormLabel>
          <CustomReactSelect
            isLoading={isLoading}
            closeMenuOnSelect={true}
            components={{ Option: TraderSelectOption }}
            options={traderOptions}
          />
    </FormControl>
  )
};